import gql from 'graphql-tag'

const serviceList = gql`query GetServiceList {
  service {
    displayText
    path
    blurb
    serviceTags
    serviceIcon {
      urls
    }
    serviceType {
      contentItems {
        displayText
      }
    }
    showOnHomePage
  }
}`

const serviceDetail = gql`query GetServiceDetail($path: String!) {
  service(where: { path: $path }) {
    displayText
    blurb
    serviceType {
      contentItems {
        displayText
      }
    }
    serviceTags
    relatedServices {
      contentItems {
        ... on Service {
          displayText
          path
        }
      }
    }
    bannerImage {
      paths
    }
    bannerContent {
      html
    }
    seoMeta {
      canonical
      pageTitle
      metaDescription
      metaKeywords
    }
  }
}`

const serviceDetail2 = gql`query GetServiceDetail2($path: String!) {
  service(where: { path: $path }) {
    bag {
      contentItems {
        ... on ContentBlockFlowpart {
          displayText
          contentBlockSubtitle
          image {
            urls
          }
          imagePosition
          markdownBody {
            html
          }
          sectionStyle
        }
        ... on Accordion {
          displayText
          subtitle
          accordionContent {
            contentItems {
              ... on AccordionItem {
                displayText
                markdownBody {
                  html
                }
              }
            }
          }
        }
        ... on Buttons {
          buttonList {
            contentItems {
              displayText
              ... on LinkMenuItem {
                linkMenuItem {
                  url
                }
              }
            }
          }
        }
        ... on HeadlineCollection {
          displayText
          bag {
            contentItems {
              ... on HeadlineItem {
                markdownBody {
                  markdown
                }
              }
            }
          }
        }
      }
    }
  }
}`

export {
  serviceList,
  serviceDetail,
  serviceDetail2
}